// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3qXHJ","buttons":"SendReceipts_buttons__zPiNI","email":"SendReceipts_email__1uQJc","bookApptTitle":"SendReceipts_bookApptTitle__248__"};